import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import CommandCenter from "@/pages/CommandCenter";
import CaseDetail from "@/pages/CaseDetail";
import Simulation from "@/pages/Simulation";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><CommandCenter /></ProtectedRoute>} />
          <Route path="/case/:id" element={<ProtectedRoute><CaseDetail /></ProtectedRoute>} />
          <Route path="/case/:id/simulation" element={<ProtectedRoute><Simulation /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}

export default App;
